// Relevance colour bands — mirrors AiScoring's thresholdMap.
// <50 → red (pastel-1), 50–74 → amber (pastel-6), 75+ → green (pastel-2).
export const matchBand = (pct: number): { light: string; dark: string } => {
  if (pct <= 49) return { light: 'pastel-1-light', dark: 'pastel-1-dark' };
  if (pct <= 74) return { light: 'pastel-6-light', dark: 'pastel-6-dark' };
  return { light: 'pastel-2-light', dark: 'pastel-2-dark' };
};

// Extracts the integer percentage from strings like "Exact match 95%".
export const parseMatchPct = (value: string): number | null => {
  const m = value.match(/(\d+)%/);
  return m ? parseInt(m[1], 10) : null;
};
